import React from "react";

// Import images
import indiaImg from "../../Assets/img/Ellipse 412.png";
import gulfImg from "../../Assets/img/Ellipse 413.png";
import africaImg from "../../Assets/img/Ellipse 420.png";
import usaImg from "../../Assets/img/Ellipse 414.png";
import europeImg from "../../Assets/img/Ellipse 415.png";

const GlobalRecruitment = () => {
  return (
    <section className="hero-section">
      <div className="hero-overlay container">
        <div className="section-header">
          <h1>Global Recruitment Experts</h1>
          <p>
            Our global recruitment expertise empowers companies to hire confidently across borders.
            Whether you're expanding in India, the Gulf, scaling in Africa, or hiring for remote
            roles in Europe or the US, we offer end-to-end hiring support designed to meet your
            international talent needs.
          </p>
        </div>

        <div className="container">
          {/* INDIA */}
          <div className="row align-items-start region-block mb-4">
            <div className="col-md-6 d-flex flex-wrap">
              <div className="region-image">
                <img src={indiaImg} alt="India" />
              </div>
              <div className="text-content ms-3">
                <strong>India</strong>
                <p>
                  Leverage our strong presence in India to hire top talent across IT, manufacturing,
                  engineering, and finance. Our local recruitment network and domain expertise ensure
                  fast, accurate placements tailored to your industry needs.
                </p>
              </div>
            </div>
          </div>

          {/* GULF */}
          <div className="row justify-content-end region-block text-start mb-4">
            <div className="col-md-6 d-flex flex-wrap ">
              <div className="region-image">
                <img src={gulfImg} alt="Gulf" />
              </div>
              <div className="text-content ms-3">
                <strong>Gulf</strong>
                <p>
                  Hire skilled professionals in Saudi Arabia, UAE, Qatar, Oman, Kuwait, and Bahrain
                  through our dedicated Gulf hiring solutions. We specialize in sourcing qualified
                  candidates for industries like oil & gas, construction, and healthcare.
                </p>
              </div>
            </div>
          </div>

          {/* AFRICA */}
          <div className="row align-items-start region-block mb-4 odd">
            <div className="col-md-6 d-flex flex-wrap">
              <div className="region-image">
                <img src={africaImg} alt="Africa" />
              </div>
              <div className="text-content ms-3">
                <strong>Africa</strong>
                <p>
                  We offer recruitment services across Africa, focusing on Nigeria, Kenya, Ghana,
                  and South Africa. We provide scalable staffing solutions customized to workforce
                  trends in construction, healthcare, and energy sectors.
                </p>
              </div>
            </div>
          </div>

          {/* UNITED STATES */}
          <div className="row justify-content-end region-block text-start mb-4">
            <div className="col-md-6 d-flex flex-wrap">
              <div className="region-image">
                <img src={usaImg} alt="USA" />
              </div>
              <div className="text-content ms-3">
                <strong>United States</strong>
                <p>
                  Our US team helps fill roles in technology, logistics, and healthcare. We offer
                  compliant staffing, remote team setup, and visa advisory services for companies
                  hiring across the US.
                </p>
              </div>
            </div>
          </div>

          {/* EUROPE */}
          <div className="row align-items-start region-block mb-4">
            <div className="col-md-6 d-flex flex-wrap">
              <div className="region-image">
                <img src={europeImg} alt="Europe" />
              </div>
              <div className="text-content ms-3">
                <strong>Europe</strong>
                <p>
                  We deliver multilingual, EU-compliant recruitment across Germany, Netherlands,
                  France, and more. Our experts support hiring in back-office, manufacturing, and
                  tech roles.
                </p>
              </div>
            </div>
          </div>

        </div>
      </div>
    </section>
  );
};

export default GlobalRecruitment;
